export { default } from './TextMpcContainer';
